<template>
  <div class="main">
    <div style="padding: 30px">

      <div style="font-weight: bold;font-size: 20px;color: #333333;">Hello~</div>
      <div style="font-size: 14px;margin-top: 10px;margin-bottom: 16px;">
        <span>欢迎</span>
        <span style="color: blue;margin: 0 4px;">登录</span>
        <span>FrameFlash</span>
      </div>
      <a-form-model id="formLogin" ref="form" class="user-layout-login" :model="form" :rules="rules">
        <a-alert v-if="isLoginError" type="error" showIcon style="margin-bottom: 24px;" :message="loginErrorInfo" closable
                 :after-close="handleCloseLoginError" />
        <a-form-model-item prop="accountNo" >
          <a-input v-model="form.accountNo" size="large" placeholder="请输入账号"  >
            <a-icon slot="prefix" type="mobile" :style="{ color: 'rgba(0,0,0,.6)' }" />
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="password">
          <a-input-password v-model="form.password" size="large" placeholder="请输入密码" :maxLength="16">
            <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.6)' }" />
          </a-input-password>
        </a-form-model-item>
        <!-- <a-row :gutter="16" v-if="captchaEnabled">
          <a-col class="gutter-row" :span="16">
            <a-form-model-item prop="code">
              <a-input v-model="form.validCode" size="large" type="text" autocomplete="off" placeholder="验证码">
                <a-icon slot="prefix" type="security-scan" :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col class="gutter-row" :span="8">
            <img class="getCaptcha" :src="codeUrl" @click="getCode">
          </a-col>
        </a-row> -->
        <!-- <a-form-model-item prop="rememberMe">
          <a-checkbox :checked="form.rememberMe" @change="rememberMe">记住密码</a-checkbox>
        </a-form-model-item> -->

        <a-form-item style="margin-top:24px">
          <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="logining"
                    :disabled="logining" @click="handleSubmit">登录</a-button>
        </a-form-item>
        <router-link class="forgetPwd" :to="{ name: 'forget',params:{code :'fromLogin'} }">分销商注册</router-link>
        <!--      <a-form-model-item prop="private">-->
        <!--        <a-checkbox :checked="form.private" @change="chooseRadio" class="text-999">已阅读并同意 <span class="text-theme" @click="showModal('user')">《用户注册协议》</span>与<span  class="text-theme" @click="showModal('privacy')">《隐私政策》</span></a-checkbox>-->
        <!--        &lt;!&ndash; <a-radio v-model:checked="form.checked" @change="chooseRadio" class="text-999"> </a-radio> &ndash;&gt;-->
        <!--      </a-form-model-item>-->
        <a-modal v-model:visible="visible" width="1000px" :title="typeTitle" >
          <template #footer>
            <!-- <a-button key="back" @click="handleCancel">Return</a-button> -->
            <a-button key="submit" type="primary" :loading="loading" @click="handleOk">我已知晓</a-button>
          </template>
          <div style="height: 500px;overflow-y: auto;">
            <div v-html="content"></div>
          </div>
        </a-modal>
        <div class="user-login-other">
          <!--
            ruoyi后台不支持获取是否开启账户.
            故此处不做隐藏处理. 在ruoyi原前端中是在注册页面定义一个属性手动修改处理.
            <router-link class="register" :to="{ name: 'register' }">注册账户</router-link>
          -->

        </div>

        <!--      <login-slider ref="loginSliderRef" @parentHandleSubmit="handleImgSubmit"-->
        <!--                    @handleImgCancel="handleImgCancel"></login-slider>-->
      </a-form-model>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { timeFix } from '@/utils/util'
import { getCodeImg,queryByGroupAndName } from '@/api/login'
import { LOGIN_USERNAME, LOGIN_PASSWORD, LOGIN_REMEMBERME } from '@/store/mutation-types'
import storage from 'store'

export default {
  components: {
  },
  data() {
    return {
      codeUrl: '',
      isLoginError: false,
      typeTitle:'',//协议标题
      content:'',//协议内容
      loginErrorInfo: '',
      visible: false,//协议弹窗
      form: {
        accountNo: '',
        password: '',
        rememberMe: false,
        private:false
      },
      rules: {
        accountNo: [{ required: true, message: '请输入手机号', trigger: 'blur' },
          // { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 16, message: '密码长度在 6 到 16 个字符', trigger: 'blur' }
        ],
      },
      logining: false,
      loading:false,
      captchaEnabled: true,
      redirect: undefined
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  created() {
    this.getStorage()
    // if (this.captchaEnabled) {
    //   this.getCode()
    // }
  },
  methods: {
    handleOk(){
      this.visible = false
    },
    showModal(type){
      this.visible = true
      if(type == 'user'){
        this.typeTitle = '用户注册协议'
      }else{
        this.typeTitle = '隐私政策'
      }
      let data={
        configGroup:'protocol',
        configName: type == 'user'?'userAgreement':'privacyPolicy'
      }
      queryByGroupAndName(data).then(res => {
        this.content= res.data.configValue
      })
    },
    chooseRadio(e) {
      this.form.private = e.target.checked
    },
    handleForgetPwd(){
      this.$router.push({ path: '/forgetPwd' || '/' })
    },
    getCode() {
      getCodeImg().then(res => {
        this.captchaEnabled = res.data.captchaEnabled === undefined ? true : res.data.captchaEnabled
        if (this.captchaEnabled) {
          this.codeUrl = 'data:image/gif;base64,' + res.data.img
          this.form.validCodeReqNo = res.data.uuid
        }
      })
    },
    getStorage() {
      const accountNo = storage.get(LOGIN_USERNAME)
      const password = storage.get(LOGIN_PASSWORD)
      const rememberMe = storage.get(LOGIN_REMEMBERME)
      if (accountNo) {
        this.form = {
          accountNo: accountNo,
          password: password,
          rememberMe: rememberMe
        }
      }
    },
    rememberMe(e) {
      this.form.rememberMe = e.target.checked
    },
    ...mapActions(['Login', 'Logout']),

    //新增
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    handleSubmit() {
      // console.log(this.form);
      // return;
      // if(!this.form.private){
      //       this.$message.error('请阅读并同意用户注册协议与隐私政策')
      //       return;
      //     }
      this.logining = true
      this.$refs.form.validate(valid => {
        console.log('valid', valid)
        if (valid) {

          // if (this.form.rememberMe) { //记住密码
          //   storage.set(LOGIN_USERNAME, this.form.accountNo)
          //   storage.set(LOGIN_PASSWORD, this.form.password)
          //   storage.set(LOGIN_REMEMBERME, this.form.rememberMe)
          // } else {
          //   storage.remove(LOGIN_USERNAME)
          //   storage.remove(LOGIN_PASSWORD)
          //   storage.remove(LOGIN_REMEMBERME)
          // }

          this.$store.dispatch('Login', this.form).then((res) => {
            console.log('999', res)
            this.$router.push({ path: this.redirect || '/' }).catch(() => { })
          }).catch((err) => {
            console.log('err', err)
            this.loading = false
            setTimeout(() => {
              this.logining = false
            }, 1000)
            // if (this.captchaEnabled) {
            //   this.getCode()
            // }
          })
          // this.Login(this.form)
          //   .then((res) => this.loginSuccess(res))
          //   .catch(err => this.requestFailed(err))
          //   .finally(() => {
          //     this.logining = false
          //   })
        } else {
          setTimeout(() => {
            this.logining = false
          }, 600)
        }
      })
    },
    loginSuccess(res) {
      this.$router.push({ path: '/' })
      // 延迟 1 秒显示欢迎信息
      setTimeout(() => {
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }, 1000)
      this.handleCloseLoginError()
    },
    requestFailed(err) {
      this.isLoginError = true
      this.loginErrorInfo = err
      this.form.code = undefined
      // if (this.captchaEnabled) {
      //   this.getCode()
      // }
    },
    handleCloseLoginError() {
      this.isLoginError = false
      this.loginErrorInfo = ''
    }
  }
}
</script>

<style lang="less" scoped>
.user-layout-login {

  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .register {
      float: right;
    }
  }
  .forgetPwd{
    color: #999999;
    font-size: 14px;
  }
  /deep/.ant-input-affix-wrapper  .ant-input{
    background: #F8FAFA;
    border: 0;
  }
}
</style>
